import { AppInsightsUserInfo } from '@mri-platform/angular-app-insights';
import { LoadedUser } from '@mri/angular-wfe-proxy-oidc';

export const getAppInsightsUserInfo = (user: LoadedUser): AppInsightsUserInfo => ({
  userId: user.sub,
  accountId: user.clientId
});
